module.exports = __webpack_public_path__ + "img/max8.69fcc521.jpg";